<template>
  <div id="app">
    <!-- <div id="nav"> -->
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    <!-- </div> -->
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'home',
    components: {
      // HelloWorld
    },
    mounted () {

      document.getElementById('shop_cart_link') != null ? document.getElementById('shop_cart_link').href = 'https://www.brighton.com/cart': ''
    }
  }
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width:1170px;
  margin: 0 auto;
  a{
    text-decoration: none;
  }
}
#nav {
  padding: 10px 0;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
